import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import GameStatsText from '~/statistics-v2/components/gameStatsText'
import { TreasureTrailProductAPIStat } from '~/statistics/types/stack-n-load.types'

export default function StatsTreasureTrail({ stats }: { stats?: TreasureTrailProductAPIStat }): React.ReactElement {
  const { t } = useTranslation('statisticsV2')

  const levelsPlayed = Object.values(stats?.details ?? {}).reduce(
    (sum, detail) => sum + (detail.completedLevels ?? 0),
    0,
  )

  const accuracy = stats?.details
    ? Math.round(
        (Object.values(stats.details).reduce((sum, detail) => sum + (detail.completedLevels ?? 0), 0) /
          Object.values(stats.details).reduce((sum, detail) => sum + (detail.totalLevels ?? 0), 0)) *
          100,
      )
    : 0

  return (
    <div className="flex flex-1 flex-col gap-2 p-4 bg-purple-midnight rounded border border-purple min-w-50">
      <div className="flex gap-2 items-center h-12">
        <ResponsiveImage height={40} srcKey="gamification/games/treasure-trail.png" width={40} />
        <h3 className="text-white text-sm font-bold">{t(`games.treasureTrail`)}</h3>
      </div>
      <span className="border-b border-purple" />
      <div className="flex flex-col gap-2 py-2">
        <GameStatsText text={t('games.levelsCompleted')} value={levelsPlayed} />
        <GameStatsText text={t('games.highestLevel')} value={stats?.summary.stageReached || 0} />
        <GameStatsText text={t('games.accuracy')} value={`${accuracy || 0}%`} />
      </div>
    </div>
  )
}
